import { HazardType } from '@/features';

export const hazardTypeRoute = (hazardType: HazardType) => {
  return hazardType.toLowerCase();
};
